// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — tooltip.styled.classic.js, новая — tooltip.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './tooltip.styled.classic';
import * as cp from './tooltip.styled.cp';

export const Block = isCp ? cp.Block : classic.Block;
export const Content = isCp ? cp.Content : classic.Content;
export const Icon = isCp ? cp.Icon : classic.Icon;
export const Text = isCp ? cp.Text : classic.Text;
